import {
    Button,
    Card,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    TextField
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import { AllowedSpecialCharacters, AllowedSpecialCharactersPaste } from "helper/regex";
import React, {
    useEffect,
    useState,
} from "react";
import { connect } from "react-redux";
import { regionCreate, regionCreateErrorClear } from "store/app/form-management/region-configuration/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";

const CreateRegion = (props) => {

    const { open, filter, paginationData, errorMessage, onClose, isPending } = props;

    const [regionData, setRegionData] = useState();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        props.regionCreateErrorClear();
        setRegionData();
        setErrors({});
    }, [open])

    const validateOnchange = (e) => {
        const { name, value } = e.target;

        setRegionData({
            ...regionData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: null,
        })
    }

    const handleRegionCreate = (e) => {
        e.preventDefault();

        const { regionName } = regionData || {};
        const currentErrors = {};

        if (!regionName && !regionName?.trim()) {
            currentErrors.regionName = 'Region name is required';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.regionCreate(regionData, filter, paginationData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Create Region
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form onSubmit={handleRegionCreate}>
                                    <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                        <Grid item >
                                            <TextField
                                                label={<div >Region Name <Required /></div>}
                                                sx={{ mt: 1 }}
                                                fullWidth
                                                autoFocus
                                                autoComplete="off"
                                                size="small"
                                                name='regionName'
                                                type='text'
                                                onChange={validateOnchange}
                                                onPaste={AllowedSpecialCharactersPaste}
                                                onKeyDown={AllowedSpecialCharacters}
                                                error={errors?.regionName}
                                                helperText={errors?.regionName}
                                            />
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleRegionCreate}
                                                size="small"
                                                color="primary"
                                                type="submit"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.regions.isRegionCreatePending,
    errorMessage: state.regions.regionCreateErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    regionCreate: (formData, filter, paginationData) => dispatch(regionCreate(formData, filter, paginationData)),
    regionCreateErrorClear: () => dispatch(regionCreateErrorClear()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateRegion);